import { store } from 'config/redux'
import { getCurrentCountry } from 'utils/appUtils'
import {
    environment,
    REACT_APP_7NOW_STRIPE_KEY_LIVE,
    REACT_APP_7NOW_STRIPE_KEY_TEST,
    version,
} from '../config/environment'

export const getFacebookKey = () =>
    environment === 'seh-prod' ? '603915923024451' : '736907843140250'

export const getStripeKey = () => {
    let training_mode = false

    const { location, user } = store.getState()
    const profile = user.toJS().userProfile
    if (profile) training_mode = profile.training_mode

    const country = getCurrentCountry(location, user)
    const live = environment === 'seh-prod' && !training_mode
    const stripeKey = live ? REACT_APP_7NOW_STRIPE_KEY_LIVE : REACT_APP_7NOW_STRIPE_KEY_TEST
    return stripeKey
}

export const getAppVersion = () => version || '1.0.26'
